import React from "react";

export const CreateAdminContext = React.createContext({
    parent: null,
});